import {Box, Card, CardActionArea, Typography} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

function OverviewCard({title, body, image, imageAlt = "", onClick}) {
    return (
        <Card
            elevation={2}
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 200ms ease, box-shadow 200ms ease',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 6,
                },
            }}
        >
            <CardActionArea
                onClick={onClick}
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                }}
            >
                <Box
                    component="img"
                    src={image}
                    alt={imageAlt}
                    sx={{
                        display: 'block',
                        width: '100%',
                        aspectRatio: '4 / 3',
                        objectFit: 'cover',
                        flexShrink: 0,
                    }}
                />
                <Box
                    sx={{
                        p: {xs: 2.5, md: 3},
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                    }}
                >
                    <Typography variant="h4" component="h3" color="primary" sx={{fontWeight: 700, mb: 1.5}}>
                        {title}
                    </Typography>
                    <Typography sx={{lineHeight: 1.6, color: 'text.secondary', textAlign: 'left'}}>
                        {body}
                    </Typography>
                    <Box
                        sx={{
                            mt: 'auto',
                            pt: 3,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                            color: 'primary.main',
                        }}
                    >
                        <Typography sx={{fontWeight: 600}}>Mehr erfahren</Typography>
                        <ArrowForwardIcon fontSize="small"/>
                    </Box>
                </Box>
            </CardActionArea>
        </Card>
    );
}

export default OverviewCard;
